(function () {
    angular
        .module('active-add-to-segment-entry.dir', [])
        .directive('activeAddToSegmentEntry', [
            '$rootScope',
            '$compile',
            '$templateCache',
            'canvasService',
            'helpers',
            activeAddToSegmentEntry,
        ]);

    function activeAddToSegmentEntry($rootScope, $compile, $templateCache, canvasService, helpers) {
        return {
            scope: {},
            controller: [
                '$scope',
                function ($scope) {
                    // extending translate method, this method not available on isolate scope
                    $scope.translate = $rootScope.translate;
                    $scope.descriptionEmpty = false;

                    $scope.getAPLSegments = () => {
                        if ($scope.lists) {
                            $scope.listView = true;
                        } else {
                            canvasService
                                .getSegmentsById($scope.data.selectedList)
                                .success((res) => {
                                    $scope.lists = res.Results;
                                    $scope.listView = true;
                                });
                        }
                    };

                    $scope.getSelectedText = (desc) => {
                        if ($scope.data.selectedList.length === 1) {
                            for (var item in desc) {
                                desc = helpers.getContactListItem(
                                    desc[item],
                                    null,
                                    $scope.segmentData
                                );
                            }

                            return desc;
                        } else {
                            var lists = [];

                            for (var i = 0; i < desc.length; i++) {
                                lists.push(
                                    helpers.getContactListItem(desc[i], null, $scope.segmentData)
                                );
                            }

                            return lists.join().replace(/,/g, '<br />');
                        }
                    };

                    $scope.showReport = () => {
                        const firstOccurrence = $scope.id.indexOf('_');
                        const secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                        const elementId = $scope.id.slice(0, secondOccurrence);
                        canvasService.getNodeDetails($rootScope.currentAPId, elementId)
                            .then((res) => res.data)
                            .then((nodeDetails) => {
                                canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType)
                                    .then(function(res){
                                        const data = [
                                            nodeDetails,
                                            res.data,
                                        ];
                                        $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                                    })
                            });
                    };

                    $scope.parseDescription = function (desc, selected) {
                        var textToParse = desc;

                        if (textToParse && typeof textToParse === 'object') {
                            var descriptionCheck = false;
                            for (var item in textToParse) {
                                if (textToParse[item]) {
                                    $scope.descriptionEmpty = false;
                                    descriptionCheck = true;
                                    var totalLists = $scope.data.selectedList.length;
                                    textToParse = helpers.getContactListItem(
                                        textToParse[item],
                                        $scope.ListName,
                                        $scope.segmentData
                                    );

                                    //One list selected and > 19
                                    if (totalLists === 1 && textToParse.length > 15) {
                                        textToParse = textToParse.slice(0, 15) + '...';
                                        //More than one selected
                                    } else if (totalLists > 1) {
                                        textToParse =
                                            totalLists +
                                            ' ' +
                                            $scope.translate(
                                                'canvas.entry.addedToSegment.selectedSegment'
                                            );
                                        //One selected but < 19
                                    } else if (totalLists === 1 && textToParse.length < 15) {
                                        textToParse = textToParse;
                                    }
                                }
                            }
                            if (!descriptionCheck) {
                                textToParse = parseDescriptionHelper(selected);
                            }
                        } else {
                            textToParse = parseDescriptionHelper(selected);
                        }

                        return textToParse;
                    };

                    //Show or hide menu on Element click
                    $scope.config = function (evt) {
                        //Show form menu
                        if ($scope.displayList === false) {
                            $scope.displayList = true;
                            $scope.listView = false;
                        } else {
                            $scope.displayList = false;
                        }
                    };

                    $scope.contMenuConfigs = 0;
                    $scope.stopMenuBroadcast = function () {
                        $scope.contMenuConfigs = 0;
                    };

                    $scope.$on('closeConfigMenus', function () {
                        if ($scope.displayList || $scope.displaySubMenu) {
                            if ($scope.contMenuConfigs === 0) {
                                $scope.contMenuConfigs = 1;
                            } else {
                                $scope.cancel();
                                $scope.displaySubMenu = false;
                                $scope.contMenuConfigs = 0;
                            }
                        } else {
                            $scope.contMenuConfigs = 0;
                        }
                    });
                    //Close menu
                    $scope.cancel = function () {
                        $scope.displayList = false;
                    };

                    var parseDescriptionHelper = function (selected) {
                        $scope.descriptionEmpty = true;
                        return selected === 'showSelectedList' ? '' : 'Description';
                    };

                    $scope.blockTrigger = () => {
                        Intercom('trackEvent', 'AP - Block Trigger');
                        const status = $scope.blocked ? 1 : 0;
                        canvasService
                            .blockJourney($rootScope.currentAPId, status)
                            .success(({ ReportInformation }) => {
                                $scope.blocked = !$scope.blocked;
                                if ($scope.blocked) {
                                    $scope.blockDate = ReportInformation.History[8];
                                }
                            });
                    };

                    $scope.description = '';
                    $rootScope.$watch('segmentData', (list) => {
                        if (list && list.length) {
                            $scope.segmentData = list;
                            const desc = $scope.parseDescription(
                                $scope.data.selectedList,
                                'showDescription'
                            );

                            if (desc) {
                                $scope.description = desc;
                            }
                        }
                    });
                },
            ],
            link: function (scope, elem, attr) {
                // scope initialization
                scope.displayList = false;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get(
                            'active_templates/entries/active-added-to-segment'
                        ),
                        modalTemplate = $templateCache.get(
                            'active_templates/entries/modal-active-added-to-segment'
                        );

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.segmentData = $rootScope.segmentData;
                    scope.numbers = '0';

                    $rootScope.segmentSelected = helpers.getContactListItem(
                        scope.data.selectedList[0],
                        '',
                        scope.segmentData
                    );

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (
                        evt,
                        data
                    ) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function (evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            },
        };
    }
})();



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/entries/active-add-to-segment-entry.js